import * as React from "react";
import { IBasePickerSuggestionsProps, Label, IPersonaProps, NormalPeoplePicker, PeoplePickerItemSuggestion, IPeoplePickerItemSuggestionStyles } from "@fluentui/react";
import { IPeoplePicker } from "../../../../../interfaces/advancedSearch/IPeoplePicker";

const suggestionProps: IBasePickerSuggestionsProps = {
  suggestionsHeaderText: "Suggested People",
  mostRecentlyUsedHeaderText: "Suggested Contacts",
  noResultsFoundText: "No results found",
  loadingText: "Loading",
  showRemoveButtons: true,
  suggestionsAvailableAlertText: "People Picker Suggestions available",
  suggestionsContainerAriaLabel: "Suggested contacts"
};

const suggestionStyles: Partial<IPeoplePickerItemSuggestionStyles> = {
  personaWrapper: {
    width: "auto"
  }
}

export const PeoplePickerInput: React.FunctionComponent<IPeoplePicker> = props => {
  const [peoplePickerList, setPeoplePickerList] = React.useState<IPersonaProps[]>([]);
  const picker = React.useRef(null);

  React.useEffect(() => {
    getUsers();
  }, []);

  const getUsers = async () => {
    setPeoplePickerList(props.allUsers);
  };

  const onFilterChanged = (
    filterText: string,
    currentPersonas: IPersonaProps[],
    limitResults?: number
  ): IPersonaProps[] | Promise<IPersonaProps[]> => {
    if (filterText) {
      let filteredPersonas: IPersonaProps[] = filterPersonasByText(filterText);
      filteredPersonas = (removeDuplicates(filteredPersonas, currentPersonas)).filter((persona, i, arr) => i === arr.findIndex(p => p.id === persona.id && p.text === persona.text));
      filteredPersonas = limitResults ? filteredPersonas.slice(0, limitResults) : filteredPersonas;
      return filterPromise(filteredPersonas);
    } else {
      return [];
    }
  };

  const filterPersonasByText = (filterText: string): IPersonaProps[] => {
    return peoplePickerList.filter(item => doesTextStartWith(item.text as string, filterText));
  };

  const filterPromise = (personasToReturn: IPersonaProps[]): IPersonaProps[] | Promise<IPersonaProps[]> => {
    return personasToReturn;
  };

  const handleOnChange = (items?: IPersonaProps[]) => {
    let personIds = items.map(item => parseInt(item.id));
    props.handleValueChange(props.searchInputData?.index, personIds);
  };

  const onRenderSuggestionsItem = React.useCallback((personaProps, suggestionsProps) => (
    <PeoplePickerItemSuggestion
      personaProps={personaProps}
      suggestionsProps={suggestionsProps}
      styles={suggestionStyles} />
  ), []);

  return (
    <div style={{ width: "100%" }}>
      <Label>{props.displayName}</Label>
      <NormalPeoplePicker
        onRenderSuggestionsItem={onRenderSuggestionsItem}
        onResolveSuggestions={onFilterChanged}
        getTextFromItem={getTextFromItem}
        pickerSuggestionsProps={suggestionProps}
        className={"ms-PeoplePicker xb-sp-input"}
        key={"normal"}
        itemLimit={props.itemLimit}
        removeButtonAriaLabel={"Remove"}
        componentRef={picker}
        onChange={handleOnChange}
        resolveDelay={300}
      />
    </div>
  );
};

function doesTextStartWith(text: string, filterText: string): boolean {
  return text?.toLowerCase()?.indexOf(filterText?.toLowerCase()) === 0;
}

function removeDuplicates(personas: IPersonaProps[], possibleDupes: IPersonaProps[]) {
  return personas.filter(persona => !listContainsPersona(persona, possibleDupes));
}

function listContainsPersona(persona: IPersonaProps, personas: IPersonaProps[]) {
  if (!personas || !personas.length || personas.length === 0) { //if we have no personas yet
    return false;
  }

  return personas.filter(item => item.text === persona.text).length > 0;
}

function getTextFromItem(persona: IPersonaProps): string {
  return persona.text as string;
}

export default PeoplePickerInput;
